import { getBrowserInfo, getSystemInfo } from "../../share/env/util.js"
import { Logger } from "../../utils/logger.js"
let _environment = ""
let _regionServerSupportedMap: Record<string, string>
let REGION = ""

/**
 * @dtsModule max.env
 * @dtsNamespace env
 * @dtsDesc env Env
 */
export const env = {
  /**
   * @dtsExport
   * Get the current runtime environment
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.env.getEnv&lang=%{locale}%)
   */
  getEnv(): string | undefined {
    return _environment
  },
  /**
   * @dtsExport
   * Get device environment information
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.env.platform&lang=%{locale}%)
   */
  platform: "web" as EnvPlatform,
  /**
   * @dtsExport
   * Get system software version
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.env.sysVersion&lang=%{locale}%)
   */
  sysVersion: getBrowserInfo() as string,
  /**
   * @dtsExport
   * Get device model
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.env.modelType&lang=%{locale}%)
   */
  modelType: getSystemInfo() as string,
  softVersion: "",
  appVersionCode: "",
  /**
   * @dtsExport
   * Get screen width
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.env.screenWidth&lang=%{locale}%)
   */
  screenWidth: document?.body?.clientWidth,
  /**
   * @dtsExport
   * Get screen height
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.env.screenHeight&lang=%{locale}%)
   */
  screenHeight: document?.body?.clientHeight,
  intranetIp: "",
  appPackageName: "",
}
export const envFn = {
  setEnv: (env: string) => {
    if (env) _environment = env
  },
  getEnv: (): string | undefined => {
    return _environment
  },
}
export const region = {
  init(region: string, regionServerSupportedMap: Record<string, string>) {
    const __region = sessionStorage.getItem("__region")
    if (__region) {
      REGION = __region
    } else if (region) {
      REGION = region
      sessionStorage.setItem("__region", region)
    } else {
      Logger.warn(`init region fail: ${__region}, ${region}`)
    }
    if (regionServerSupportedMap) {
      _regionServerSupportedMap = regionServerSupportedMap
    } else {
      Logger.warn(
        `init region map fail: ${JSON.stringify(_regionServerSupportedMap)}`
      )
    }
  },
  set(region: string) {
    if (REGION === region) return false
    if (_regionServerSupportedMap && !_regionServerSupportedMap[region]) {
      Logger.warn(
        `set region fail: ${region} not found in ${JSON.stringify(
          _regionServerSupportedMap
        )}`
      )
      return false
    }
    REGION = region
    sessionStorage.setItem("__region", region)
    return true
  },
  get() {
    return REGION
  },
  getMap() {
    return _regionServerSupportedMap
  },
}
